import { render, staticRenderFns } from "./AdminActivityGroups.vue?vue&type=template&id=0b1082a2&"
import script from "./AdminActivityGroups.vue?vue&type=script&lang=js&"
export * from "./AdminActivityGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports